import Image from 'components/atoms/Image/Image';
import React from 'react';
import firefoxHelp1 from './FirefoxAppHelpImages/firefoxHelp1.png';
import firefoxHelp2 from './FirefoxAppHelpImages/firefoxHelp2.png';
import firefoxHelp3 from './FirefoxAppHelpImages/firefoxHelp3.png';

export interface Props {}

const FirefoxAppHelp: React.FC<Props> = () => {
  return (
    <>
      <h1>Install Help - Firefox</h1>
      <ol>
        <li>
          <p>
            Click the <strong>Get the Browser App</strong> button. Click the{' '}
            <strong>Continue to Installation</strong> button.
          </p>
          <Image quality={100} src={firefoxHelp1} alt="firefox-extension-instruction" />
        </li>
        <li>
          <p>
            Next click the <strong>Add</strong> button.
          </p>
          <Image quality={100} src={firefoxHelp2} alt="firefox-add-instruction" />
        </li>
        <li>
          <p>
            Firefox will let you know that the browser app has been added. You can try the browser
            app by clicking on your favourite search site.
          </p>
          <Image quality={100} src={firefoxHelp3} alt="firefox-try-app-instruction" />
        </li>
      </ol>
    </>
  );
};

export default FirefoxAppHelp;
